// Module
var code = "<h2 id=\"youcandealwithitcom\">YouCanDealWithIt.com</h2> <p>YouCanDealWithIt.com provides practical advice on how to deal with common financial solutions facing today&#39;s college students and recent graduates.</p> ";
// Exports
export default code;